customElements.define(
  "rte-accordion",
  class extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector(".rte-accordion__content");
      this.gradient = this.querySelector(".rte-accordion__gradient");
      this.toggle = this.querySelector(".rte-accordion__toggle");
      this.expanded = false;
      const maxHeight = parseInt(
        getComputedStyle(this).getPropertyValue("--rte-max-height")
      );
      if (this.content.scrollHeight <= maxHeight) {
        this.gradient.remove();
        this.toggle.remove();
        return;
      }
      this.toggle.addEventListener("click", () => this.handleToggle());
    }
    handleToggle() {
      this.expanded = !this.expanded;
      if (this.expanded) {
        this.content.style.maxHeight = this.content.scrollHeight + "px";
        this.gradient.style.opacity = "0";
        this.toggle.parentElement.style.display = "none";
      } else {
        this.content.style.maxHeight = "";
        this.gradient.style.opacity = "1";
        this.toggle.parentElement.style.display = "";
      }
    }
  }
);
